import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponentBase } from '@shared/app-component-base';
import { AccountServiceProxy, ResetPasswordInput } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent extends AppComponentBase implements OnInit {
  
  loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  token : string ;
  password : string;
  passwordAgain : string ;

  constructor(
    injector : Injector,
    private _route: ActivatedRoute,
    private _accountService : AccountServiceProxy
  ) {
    super(injector);
  }

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.token = params['t'];
    });
  }

  submit() {

   

    if(! this.formValidation()){
      return ;
    }

    this.loading$.next(true);

    var input : ResetPasswordInput = new ResetPasswordInput();
    input.newPassword = this.password ;
    input.token = this.token ;
    
    this._accountService.resetPassword(input)
      .subscribe(() =>{
        this.loading$.next(false);
      }, 
      ()=>{
        //Error;
        this.loading$.next(false);
      });
  } 

  formValidation () : boolean {

    if (this.password.length < 6){
        const message = this.l(this.stringFormat("MESSAGE.PASSWORD.LIMIT","6"));
        this.uiMessage.modal.warning(this.l("WARNING"), message, null);

        return false ;
    }
    else if(this.password != this.passwordAgain){
        const message = this.l("MESSAGE.PASSWORD.VALIDATION");
        this.uiMessage.modal.warning(this.l("WARNING"), message, null);

        return false ;
    }

    return true ;
  }
}
